import { getLooups, getNetworkLu ,getCurrency} from "../components/createpaymentlink/service";
import { getCommissionData } from "../components/dashboard.component/api";
import { isErrorDispaly } from "../shared/validationsAndExceptions/apiExceptions";

const SET_CURRENCY_LU = "setCurrencyLookup"
const SET_NETWORKS_LU = "setNetworksData";
const SET_TRASFER_FORM_DATA = 'setTrasferFormData';
const SET_MERCHANT_LU = 'merchantLookup';
const SET_CURRENCY = 'currencyData';
const SETCOMMISSIONDETAILS = 'setCommissionDetails';
const SET_PENDING_COMMISSION_SAVE_DATA = 'setPendingCumisionSaveData';
const SET_TRASFER_SAVE_DATA = 'setTrasferSaveData';

const setTrasferFormData = (payload) => {
    return {
        type: SET_TRASFER_FORM_DATA,
        payload
    }
}
const setTrasferSaveData = (payload) => {
    return {
        type: SET_TRASFER_SAVE_DATA,
        payload
    }
}
const setCurrencyLookup = (payload) => {
    return {
        type: SET_CURRENCY_LU,
        payload
    }
}
const setNetworksData = (payload) => {
    return {
        type: SET_NETWORKS_LU,
        payload
    }
}
const setMerchantData = (payload) => {
    return {
        type: SET_MERCHANT_LU,
        payload
    }
}
const setCurrencyData = (payload) => {
    return {
        type: SET_CURRENCY,
        payload
    }
}
export const setCommissionDetails = (payload) => {
    return {
        type: SETCOMMISSIONDETAILS,
        payload
    }
}
const setPendingComisionSaveData = (payload) => {
    return {
        type: SET_PENDING_COMMISSION_SAVE_DATA,
        payload
    }
}
let initialState = {
        currencyLookup : { isLoading: false,data: [], error: null},
        networkLookup : { isLoading: false, data: [], error: null},
        trasferFormData:{},
        commissionDetails:{ isLoader: false,data: null, error: null},
        pendingCommisionSaveData:{},
        trasferSaveData:{},
}

export const fetchCurrencyLookup = ( userId) => async (dispatch) => {
    try {
        dispatch(setCurrencyLookup({ key: "currencyLookup", isLoading: true, data: [],error: null }));
        let response = await getLooups('Merchant/CurrencyLookUp', userId);
        if (response.success) {
            dispatch(setCurrencyLookup({ key: "currencyLookup", isLoading: false, data: response.data }));
        } else {
            dispatch(setCurrencyLookup({ key: "currencyLookup", isLoading: false, data: [], error:isErrorDispaly(response.error) }));       
        }
    } catch (error) {
        dispatch(setCurrencyLookup({ key: "currencyLookup", isLoading: false, data: [], error:isErrorDispaly(error) }));
    }
};
export const fetchMerchantLookup = ( userId) => async (dispatch) => {
    try {
        dispatch(setMerchantData({ key: "merchantLookup", isLoading: true, data: [],error: null }));
        let response = await getLooups('Merchant/merchantslookup', userId);
        if (response.success) {
            dispatch(setMerchantData({ key: "merchantLookup", isLoading: false, data: response.data }));
        } else {
            dispatch(setMerchantData({ key: "merchantLookup", isLoading: false, data: [], error:isErrorDispaly(response.error) }));       
        }
    } catch (error) {
        dispatch(setMerchantData({ key: "merchantLookup", isLoading: false, data: [], error:isErrorDispaly(error) }));
    }
};
export const fetchCurrency = (coin,network,merchant,id) => async (dispatch) => {
    try {
        dispatch(setCurrencyData({ key: "currencyData", isLoading: true, data: null,error: null }));
        let response = await getCurrency('Merchant/balancetransfer', coin,network,merchant,id);
        if (response.success) {
            dispatch(setCurrencyData({ key: "currencyData", isLoading: false, data: response.data }));
        } else {
            dispatch(setCurrencyData({ key: "currencyData", isLoading: false, data: null, error:isErrorDispaly(response.error) }));       
        }
    } catch (error) {
        dispatch(setCurrencyData({ key: "currencyData", isLoading: false, data: null, error:isErrorDispaly(error) }));
    }
};

export const fetchNetworks = (currency, id) => async (dispatch) => {
    try {
        dispatch(setNetworksData({ key: "networkLookup", isLoading: true, data: [] ,error: null }));
        let response = await getNetworkLu('Merchant/NetWorkLookUp', currency,id);
        if (response.success) {
            dispatch(setNetworksData({ key: "networkLookup", isLoading: false, data: response.data }));
        } else {
            dispatch(setNetworksData({ key: "networkLookup", isLoading: false, data: [], error:isErrorDispaly(response.error) }));
        }
    } catch (error) {
        dispatch(setNetworksData({ key: "networkLookup", isLoading: false, data: [], error:isErrorDispaly(error) }));
    }
};

export const fetchCommissionDeatails = (customerId,callBack) => async (dispatch) => {
    try {
        dispatch(setCommissionDetails({ key: "commissionDetails", isLoader: true, data: null,error: null }));
        let response = await getCommissionData('/Merchant/pendingcommissions/',customerId);
        if (response.ok) {
            callBack(response)
            dispatch(setCommissionDetails({ key: "commissionDetails", isLoader: false, data: response.data }));
        } else {
            callBack(isErrorDispaly(response.error))
            dispatch(setCommissionDetails({ key: "commissionDetails", isLoader: false, data: null, error:isErrorDispaly(response.error) }));       
        }
    } catch (error) {
        callBack(isErrorDispaly(error))
        dispatch(setCommissionDetails({ key: "commissionDetails", isLoader: false, data: null, error:isErrorDispaly(error) }));
    }
};

const trasferReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_CURRENCY_LU:
            return {
                ...state, [action.payload.key]: {
                    data: action.payload.data,
                    error: action.payload.error,
                    isLoading: action.payload.isLoading,
                },
            };
        case SET_MERCHANT_LU:
            return {
                ...state, [action.payload.key]: {
                    data: action.payload.data,
                    error: action.payload.error,
                    isLoading: action.payload.isLoading,
                },
            };
        case SET_CURRENCY:
            return {
                ...state, [action.payload.key]: {
                    data: action.payload.data,
                    error: action.payload.error,
                    isLoading: action.payload.isLoading,
                },
            };
        case SET_NETWORKS_LU:
            return {
                ...state, [action.payload.key]: {
                    data: action.payload.data,
                    error: action.payload.error,
                    isLoading: action.payload.isLoading,
                }
            };
        case SET_TRASFER_FORM_DATA:
            return { ...state, trasferFormData: action.payload };
        case SET_TRASFER_SAVE_DATA:
            return { ...state, trasferSaveData: action.payload };
        case SETCOMMISSIONDETAILS:
            return {
                ...state, [action.payload.key]: {
                    data: action.payload.data,
                    error: action.payload.error,
                    isLoader: action.payload.isLoading,
                },
            };
        case SET_PENDING_COMMISSION_SAVE_DATA:
                return { ...state, pendingCommisionSaveData: action.payload };
        default:
            return state;
    }
}
export default trasferReducer;
export {setTrasferFormData,setCurrencyLookup,setNetworksData,setMerchantData,setCurrencyData,setPendingComisionSaveData,setTrasferSaveData}